
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsOkDone3X = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 276,
  height: 276,
  preserveAspectRatio: "none",
  viewBox: "0 0 1104 1104"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M942.722 204.254a37.805 37.805 0 0 1 2.893-.198c20.628-.605 38.282 13.41 38.474 34.956.121 13.596-4.135 20.514-13.467 29.899-34.492 34.687-68.912 69.46-103.468 104.094L669.487 570.82l-101.08 101.376c-16.148 16.215-42.66 46.194-62.058 57.214-18.67 10.607-40.412-6.756-51.916-20.074-5.918-6.852-15.407-15.454-22.613-22.669l-79.52-79.636c-14.436-14.169-38.838-33.273-40.438-53.925-2.218-28.652 32.03-49.838 55.466-32.167 15.869 11.966 30.506 28.322 44.67 42.5l81.344 81.688c10-12.973 43.828-45.386 56.592-58.182L664.08 472.561l170.465-170.516 54.962-55.085c10.956-10.98 21.898-22.246 33.301-32.746 6.862-6.317 11.294-7.78 19.914-9.96z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M511.268 0h49.56c10.958 5.65 21.854 11.487 25.72 24.114a38.614 38.614 0 0 1-2.908 29.695c-12.646 22.983-43.14 18.246-65.939 19.978a478.872 478.872 0 0 0-65.473 9.081C187.102 137.74 18.669 410.553 88.176 672.66c67.411 254.201 326.476 409.45 581.231 343.92 126.301-32.486 232.569-111.892 298.033-225.031a481.706 481.706 0 0 0 60.58-183.42c1.97-17.889.77-54.169 6.25-68.131 13.24-33.701 56.4-30.311 69.73 3.851v49.661c-2.45 12.387-3.32 24.975-5.08 37.468-22 156.189-112.68 297.795-244.952 383.622-69.533 45.12-147.233 72.81-228.957 85.08-8.733 1.31-20.111 1.66-28.312 4.32h-88.217c-10.691-3.2-43.963-6.3-58.769-9.18a571.669 571.669 0 0 1-154.701-54.1C161.499 970.29 62.498 848.441 20.895 703.338c-8.007-27.56-13.979-55.586-16.937-84.151-.79-7.634-1.658-19.845-3.958-26.582v-81.106c2.938-7.885 3.292-28.267 4.904-38.201a654.985 654.985 0 0 1 16.603-75.927C74.045 218.146 213.386 77.478 392.105 23.243c24.604-7.309 48.297-12.81 73.687-16.728 7.521-1.16 41.74-4.075 45.476-6.515z"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"276\" height=\"276\" preserveAspectRatio=\"none\"  viewBox=\"0 0 1104 1104\" id=\"5ccdb5a1-cbea-37d0-b3ca-d5a5dde38b58\">\r\n  <path fill=\"var(--theme-primary, #810ea9)\" d=\"M 942.722 204.254 C 943.684 204.151 944.648 204.085 945.615 204.056 C 966.243 203.451 983.897 217.466 984.089 239.012 C 984.21 252.608 979.954 259.526 970.622 268.911 C 936.13 303.598 901.71 338.371 867.154 373.005 L 669.487 570.82 L 568.407 672.196 C 552.259 688.411 525.747 718.39 506.349 729.41 C 487.679 740.017 465.937 722.654 454.433 709.336 C 448.515 702.484 439.026 693.882 431.82 686.667 L 352.3 607.031 C 337.864 592.862 313.462 573.758 311.862 553.106 C 309.644 524.454 343.892 503.268 367.328 520.939 C 383.197 532.905 397.834 549.261 411.998 563.439 L 493.342 645.127 C 503.342 632.154 537.17 599.741 549.934 586.945 L 664.08 472.561 L 834.545 302.045 L 889.507 246.96 C 900.463 235.98 911.405 224.714 922.808 214.214 C 929.67 207.897 934.102 206.434 942.722 204.254 z\"></path>\r\n  <path fill=\"var(--theme-primary, #810ea9)\" d=\"M 511.268 0 L 560.828 0 C 571.786 5.65017 582.682 11.4874 586.548 24.1143 C 589.596 34.0022 588.549 44.6998 583.64 53.8087 C 570.994 76.7924 540.5 72.0551 517.701 73.7874 C 495.694 75.3028 473.817 78.337 452.228 82.8685 C 187.102 137.739 18.669 410.553 88.1763 672.66 C 155.587 926.861 414.652 1082.11 669.407 1016.58 C 795.708 984.094 901.976 904.688 967.44 791.549 C 999.809 735.126 1020.42 672.732 1028.02 608.129 C 1029.99 590.24 1028.79 553.96 1034.27 539.998 C 1047.51 506.297 1090.67 509.687 1104 543.849 L 1104 593.51 C 1101.55 605.897 1100.68 618.485 1098.92 630.978 C 1076.92 787.167 986.24 928.773 853.968 1014.6 C 784.435 1059.72 706.735 1087.41 625.011 1099.68 C 616.278 1100.99 604.9 1101.34 596.699 1104 L 508.482 1104 C 497.791 1100.8 464.519 1097.7 449.713 1094.82 C 395.815 1084.31 343.713 1066.09 295.012 1040.72 C 161.499 970.29 62.4977 848.441 20.8946 703.338 C 12.8879 675.778 6.91617 647.752 3.95815 619.187 C 3.16768 611.553 2.29971 599.342 0 592.605 L 0 511.499 C 2.93784 503.614 3.29233 483.232 4.9042 473.298 C 8.93063 447.682 14.4746 422.329 21.5067 397.371 C 74.0451 218.146 213.386 77.4777 392.105 23.2428 C 416.709 15.934 440.402 10.4326 465.792 6.51535 C 473.313 5.35497 507.532 2.44044 511.268 0 z\"></path>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-ok-done@3x.53f98ced94ef08ebd1563c92de9ddb9e.svg"),
        {
          React: SvgIconsOkDone3X,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      